module.exports = __webpack_public_path__ + "static/media/minus.f3c9b404.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/minus.svg
// module id = 139
// module chunks = 0